<script setup>
import { ref, reactive, onMounted } from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import { ChevronDoubleRightIcon, ChevronDoubleLeftIcon } from '@heroicons/vue/outline'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  }
})

const show = ref(false)
const deleting = ref(false)
let commands = reactive([])
let selectedDevice = ref(props.data.devices[0].external_identifier)

const selectDevice = ($event) => {
  selectedDevice.value = $event.target.value
}

const addCommand = (command) => {
  commands.push(command)
  console.log(command, commands)
}

const removeCommand = (key) => {
  commands.splice(key, 1)
  deleting.value = false
}

const start = () => {
  const channel = window.Echo.private(`devices.${selectedDevice.value}`)
  setTimeout(() => {
    channel.whisper('run_commands', commands)
    show.value = false
    commands.length = 0
  }, 1000)
}

</script>

<template>
  <div class="flex justify-center items-center">
    <div
      class="bg-slate-600 select-none hover:bg-slate-700 cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
      @click="show = true">
      Commands
    </div>
    <Teleport to="body">
      <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-10" @close="show = false">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                           leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </TransitionChild>

          <div class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <TransitionChild as="template" enter="ease-out duration-300"
                               enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                               enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                               leave-from="opacity-100 translate-y-0 sm:scale-100"
                               leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <DialogPanel
                  class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                  <div>
                    <div class="mt-3 text-center sm:mt-5">
                      <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                        Kies commando's
                      </DialogTitle>
                      <div class="mt-2 flex justify-between items-stretch">
                        <div class="w-5/12 pr-4 flex justify-center items-center flex-col">
                          <p class="select-none text-sm leading-5 text-gray-500 py-2 hover:bg-green-100 block w-full cursor-pointer" v-for="command in ['Retours', 'SST', 'Test']" @click="addCommand(command)">
                            {{ command }}
                          </p>
                        </div>
                        <div class="w-2/12 flex justify-center items-center">
                          <ChevronDoubleLeftIcon class="w-6 h-6" v-if="deleting" />
                          <ChevronDoubleRightIcon class="w-6 h-6" v-else />
                        </div>
                        <div class="w-5/12 pl-4 max-h-48 overflow-y-auto">
                          <p class="select-none text-sm leading-5 text-gray-500 py-2 hover:bg-red-100 block w-full cursor-pointer"
                             v-for="(command, key) in commands"
                             @click="removeCommand(key)"
                             @mouseover="deleting = true"
                             @mouseleave="deleting = false"
                          >
                            {{ key + 1 }}. {{ command }}
                          </p>
                        </div>
                      </div>
                      <div class="mt-4">
                        Kies een apparaat:
                      </div>
                      <div class="mt-2">
                        <select
                          class="my-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                          @change="selectDevice"
                        >
                          <option
                            :value="device.external_identifier"
                            v-for="(device, key) in data.devices"
                          >
                            {{ device.node_name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    <button type="button"
                            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                            @click="start">
                      Start
                    </button>
                    <button type="button"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                            @click="show = false"
                            ref="cancelButtonRef">
                      Cancel
                    </button>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </Teleport>
  </div>
</template>
